(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bi/moser/moser.min"), require("polyglot"));
	else if(typeof define === 'function' && define.amd)
		define(["bi/moser/moser.min", "polyglot"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("bi/moser/moser.min"), require("polyglot")) : factory(root["bi/moser/moser.min"], root["polyglot"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__5__) {
return 